import { get } from "../../../api/axios-client";
import { Invoice } from "../models/logisticsTypes";

const controllerUrl = "api/Logistics/";

export const InvoiceAPI = {
  getFilteredInvoices: async (
    startDate?: string,
    endDate?: string,
    searchQuery?: string,
    isRentalContractEnabled?: boolean,
    WorkOrderStatusIds?: string[],
    locationId?: string,
    pickupStartDate?: string,
    pickupEndDate?: string,
    deliveryStartDate?: string,
    deliveryEndDate?: string
  ): Promise<Invoice[] | null> => {
    try {
      const params: string[] = [];
      if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
      if (searchQuery !== undefined && searchQuery !== null)
        params.push(`searchQuery=${encodeURIComponent(searchQuery)}`);

      // Handle multi-select work order status IDs
      if (WorkOrderStatusIds !== undefined && WorkOrderStatusIds !== null && WorkOrderStatusIds.length > 0) {
        // Send as comma-separated values
        params.push(`WorkOrderStatusIds=${encodeURIComponent(WorkOrderStatusIds.join(","))}`);
      }
      if (locationId !== undefined && locationId !== null && locationId !== "0") {
        params.push(`locationId=${encodeURIComponent(locationId)}`);
      }
      if (
        isRentalContractEnabled !== undefined &&
        isRentalContractEnabled !== null
      ) {
        params.push(`isRentalContractEnabled=${isRentalContractEnabled}`);
      }
      // Add pickup date range filter
      if (pickupStartDate !== undefined && pickupStartDate !== null) {
        params.push(`pickupStartDate=${encodeURIComponent(pickupStartDate)}`);
      }
      if (pickupEndDate !== undefined && pickupEndDate !== null) {
        params.push(`pickupEndDate=${encodeURIComponent(pickupEndDate)}`);
      }
      // Add delivery date range filter
      if (deliveryStartDate !== undefined && deliveryStartDate !== null) {
        params.push(`deliveryStartDate=${encodeURIComponent(deliveryStartDate)}`);
      }
      if (deliveryEndDate !== undefined && deliveryEndDate !== null) {
        params.push(`deliveryEndDate=${encodeURIComponent(deliveryEndDate)}`);
      }
      const query = params.length ? `?${params.join("&")}` : "";
      //debugger;
      const { data } = await get(`${controllerUrl}GetFilteredInvoices${query}`);
      return data as Invoice[];
    } catch (error) {
      throw error;
    }
  },
};

export default InvoiceAPI;
